import React from "react"
import * as specialmessagestyles from "./product-special-message.module.css"

export default function SpecialMessage() {
    return (
        <div className={specialmessagestyles.messagecustomer}>
            <p>For international sales, we only sell to authorized distributors. We protect and support all our distributors worldwide. For US sales, please order directly.</p>
        </div>
    )
}